import { JobMediaGalleryEditor } from '@/components/jobs/job-media-gallery-editor'
import type { Job } from '@/types'

interface JobMediaPanelProps {
  job: Job
}

export function JobMediaPanel({ job }: JobMediaPanelProps) {
  return (
    <JobMediaGalleryEditor
      job={job}
      title="Job Media"
      description="Documents, images, video, and proof files linked to this job."
    />
  )
}
